/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface BaseReportRequest
 */
export interface BaseReportRequest {
    /**
     * Date from, inclusive. Date only, eg '2023-10-04'. Reports are run using AEST only (UTC+10, no daylight savings)
     * @type {string}
     * @memberof BaseReportRequest
     */
    dateFrom?: string;
    /**
     * Date to, inclusive. Date only, eg '2023-10-04'. Reports are run using AEST only (UTC+10, no daylight savings)
     * @type {string}
     * @memberof BaseReportRequest
     */
    dateTo?: string;
    /**
     * Report is run for all operational devices in this group. Prefer using DeviceGroupTags instead.
     * @type {string}
     * @memberof BaseReportRequest
     */
    deviceGroupTag?: string;
    /**
     * Report is run for all operational devices in the intersection of all of these groups. Clients must provide at least one group they are directly assigned to, eg their org or a site. They may also provide groups they are not directly assigned to, eg ServiceModels
     * @type {Array<string>}
     * @memberof BaseReportRequest
     */
    deviceGroupTags?: Array<string>;
}

/**
 * Check if a given object implements the BaseReportRequest interface.
 */
export function instanceOfBaseReportRequest(
    value: object,
): value is BaseReportRequest {
    return true;
}

export function BaseReportRequestFromJSON(json: any): BaseReportRequest {
    return BaseReportRequestFromJSONTyped(json, false);
}

export function BaseReportRequestFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): BaseReportRequest {
    if (json == null) {
        return json;
    }
    return {
        dateFrom: json["dateFrom"] == null ? undefined : json["dateFrom"],
        dateTo: json["dateTo"] == null ? undefined : json["dateTo"],
        deviceGroupTag:
            json["deviceGroupTag"] == null ? undefined : json["deviceGroupTag"],
        deviceGroupTags:
            json["deviceGroupTags"] == null
                ? undefined
                : json["deviceGroupTags"],
    };
}

export function BaseReportRequestToJSON(value?: BaseReportRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        dateFrom: value["dateFrom"],
        dateTo: value["dateTo"],
        deviceGroupTag: value["deviceGroupTag"],
        deviceGroupTags: value["deviceGroupTags"],
    };
}
